import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Fieldtypes } from '../../../../../core/entities/fieldtypes.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsFieldtypesComponent } from './dialogs-fieldtypes/edit-dialogs-fieldtypes/edit-dialogs-fieldtypes.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-fieldtypes',
  templateUrl: './fieldtypes.component.html',
  styleUrls: ['./fieldtypes.component.scss']
})
export class FieldtypesComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  fieldtype: Fieldtypes = new Fieldtypes();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllFieldtypes();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla fieldtypes
  */
  private getAllFieldtypes(): void {
    this.loading = true;
    this.internalHomeService.allFieldtypes().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un fieldtype
  * @param fieldtype Opcional. Fieldtype vacio.
  */
  public createFieldtype(fieldtype?: Fieldtypes) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    fieldtype = this.fieldtype;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsFieldtypesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { fieldtype, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllFieldtypes();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un fieldtype
  * @param fieldtype Opcional. Fieldtype a editar.
  */
  public editFieldtype(fieldtype?: Fieldtypes) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsFieldtypesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: {fieldtype, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllFieldtypes();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un fieldtype
  * @param fieldtype Fieldtype a eliminar
  */
  public removeFieldtype(fieldtype?: Fieldtypes) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_fieldtypes') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeFieldtypes(fieldtype).subscribe(res => {
          console.log(res);
          this.getAllFieldtypes();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
